
import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';

import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import { NicaDynamicContentComponent } from '../../components/nica-dynamic-content/nica-dynamic-content.component';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { alert } from 'devextreme/ui/dialog';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import notify from 'devextreme/ui/notify';
import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';
import { NicaDataGridComponent } from '../../components/nica-data-grid/nica-data-grid.component';


@Component({
  selector: 'app-autorizzazione',
  templateUrl: './ana-autorizzazione.component.html',
  styleUrls: ['./ana-autorizzazione.component.css']
})
export class AnaAutorizzazioneComponent extends NicaMaster implements OnInit,AfterContentChecked {
  @ViewChild('formAnagrafica', { static: false }) formAnagrafica: NewNicaFormComponent;
  @ViewChild('dynamicComponent', { static: false }) dynamicComponent: NicaDynamicContentComponent;
  @ViewChild('dataAutorizzazioneCer', { static: false }) dataAutorizzazioneCer: NicaDataGridComponent;
  @ViewChild('nicaAnagrafica', { static: false }) nicaAnagrafica: NicaAnagraficaComponent;

  @Input() itemData: any
  @Input() InviaA: any
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>();
  autorTabs: any[];
  autorizzazioneCerData: any[] = [];
  showDynamicComponent: boolean = false
  templateTab: any = {
    autorizzazione: 'grid',
    autorizzazionearea: 'grid',
    autorizzazionecer: 'dynamicGrid'
  }
  selectedIndex: any =
    {
      autorizzazione: 0,
      autorizzazionecer: 1,
      autorizzazionearea: 2
    }
  autorizzazioneCerDataChanged: any[] = [];
  customButtonToolbarBottom: any = [];
  guidPop: string;


  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public loader: NgxSpinnerService,
    public formservice: FormsTemplateService,
    private cdr : ChangeDetectorRef
  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService

    );


  }

  ngAfterContentChecked(){
    this.cdr.detectChanges();
  }

  ngOnInit(): void {

    

    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])
      this.setViewsAutorizzazioneComponent(this.itemData[0])

    } else {

      this.activatedroute.queryParams.subscribe((params) => {
        //console.log(params)
        this.currentTabId = params.currentTabId,
          this.currentTabName = params.currentTabName

        this.setGlobalVariableFromParams(params)

        //this.SetToolbarButtons(this.serviceButtonsArray, null, '', '', true);

        this.setViewsAutorizzazioneComponent(params)
      })
    }

  }

  setViewsAutorizzazioneComponent(params) {

    this.setTabsAutorizzazioni(params);
    
    if (this.SubjectCall == 'autorizzazionearea' && this.template == 'grid' || this.SubjectCall == 'autorizzazionecer') {
      this.SetToolbarButtons(this.serviceButtonsArray, this.filterID, null, null, true)
    }

 
    if (this.SubjectCall == 'autorizzazionecer') {
      this.loader.show()
      this.getDataAutorCer();

      //15 è il bottone di salvataggio
      this.buttonToolbarBottomGrid.unshift(15)
      /* .unshift(

        {
          id: 1,
          location: "after",
          widget: "dxButton",
          locateInMenu: "never",
          useSubmitBehavior: true,
          template: false,
          options:
          {
            stylingMode: "text",
            text: 'Salva',
            icon: "glyphicon icon-salva-form",
            visible: true,
            onClick: ($event) => {
              this.loader.show();

              this.submitAutorizzazioneCer()
            },


          }

        }




      ) */

    }



  }

  emitGeneralButtonsWrapper(e){

    console.log('emettiChiusuraCaption', e)

   
    if (e == 'close') {
      let event = { event: 5 }
      this.buttonEmitted(event)
    }

    if (e == 'closeToolbar') {

      if (!this.isOpen) {
        this.openToolBar()
      } else {
        this.closeToolBar()
      }


    }

    if (e == 'ritorna') {
      this.returnPrevUrl()
      
    }
    if (e == 15) {
      this.submitAutorizzazioneCer()
    }
  }

  setTabsAutorizzazioni(param) {

    this.selectedIndex[this.SubjectCall];

    if(!this.filterID['isEdit'] && this.SubjectCall == 'autorizzazione'){

      delete this.filterID['idAutorizzazione'];
      
    }

    this.autorTabs = [
      {
        name: 'Autorizzazione',
        icon: 'glyphicon icon-autorizzazioni-form',
        hint: 'Autorizzazion',
        displayMode: 'in-line',
        path: 'main/anagrafica-autorizzazione',
        componentName: 'AnaAutorizzazioneComponent',
        service: 'autorizzazione',
        api: 'Autorizzazione',
        templateComponent: this.templateTab[this.SubjectCall],
        visible: true,
        disabled: false
      },
      {
        name: 'Autorizzazioni EER',
        icon: 'glyphicon icon-autorizzazioni-form',
        hint: 'Autorizzazioni EER',
        displayMode: 'in-line',
        path: 'main/anagrafica-autorizzazione',
        componentName: 'AnaAutorizzazioneComponent',
        service: 'autorizzazionecer',
        api: 'AutorizzazioneCer',
        templateComponent: 'dynamicGrid',
        visible: true,
        disabled: this.filterID['idAutorizzazione'] ? false : true

      },
      {
        name: 'Autorizzazioni Area',
        icon: 'glyphicon icon-autorizzazioni-form',
        hint: 'Autorizzazioni Area',
        displayMode: 'in-line',
        path: 'main/anagrafica-autorizzazione',
        componentName: 'AnaAutorizzazioneComponent',
        service: 'autorizzazionearea',
        api: 'AutorizzazioneArea',
        templateComponent: this.templateTab[this.SubjectCall],
        visible: this.filterID['nsAzienda'],
        disabled: this.filterID['idAutorizzazione'] ? false : true
      },

    ]

  }

  tabClick(ev) {
    this.loader.show();
  
    let data = [];
    const itemData = ev.itemData;
    this.continueTabChange(ev);
    // Controlla se l'utente sta cercando di cambiare scheda senza salvare le modifiche nella griglia
    if (itemData.service !== this.SubjectCall && this.template === 'dynamicGrid' && this.dataAutorizzazioneCer.inEditState) {
      alert('Ci sono modifiche non salvate. Vuoi procedere senza salvare?', 'Attenzione').then(() => {
        // Prosegui senza salvare
        this.continueTabChange(ev);
      });
      // Annulla il cambiamento di scheda nascondendo il loader
      this.loader.hide();
    }
  }
  
  continueTabChange(ev) {
    let data = [];
    const itemData = ev.itemData;
  
    if (this.template == 'form') {
      const validation = this.formAnagrafica.validate();
      if (validation.isValid) {
        this.formAnagrafica.onFormSubmit();
      } else {
        this.loader.hide();
        return;
      }
    }
  
    if (this.template == 'dynamicGrid') {
      this.submitAutorizzazioneCer();
    }
  
    setTimeout(() => {
      let filterID = this.filterID;
  
      switch (this.SubjectCall) {
        case 'autorizzazione':
          data = this.formAnagrafica.dataSet;
          this.filterID['idAutorizzazione'] = data['id'];
  
          if (this.filterID['idAutorizzazioneArea'] && this.filterID['templateTab']['autorizzazionearea'] == 'form') {
            data['id'] = this.filterID['idAutorizzazioneArea'];
          }
  
          if (typeof this.filterID['templateTab'] != 'undefined') {
            this.filterID['templateTab']['autorizzazione'] = this.template;
          } else {
            this.filterID['templateTab'] = this.templateTab;
            this.filterID['templateTab']['autorizzazione'] = this.template;
          }
          break;
  
        case 'autorizzazionearea':
          if (this.template == 'form') {
            data = this.formAnagrafica.dataSet;
            this.filterID['idAutorizzazioneArea'] = data['id'];
          } else {
            data = this.filterID;
            this.filterID['idAutorizzazioneArea'] = data['idAutorizzazioneArea'];
          }
  
          if (itemData.service == 'autorizzazione') {
            data['id'] = data['idAutorizzazione'];
            this.filterID['isEdit'] = true;
          }
          this.filterID['idAutorizzazione'] = data['idAutorizzazione'];
  
          this.templateTab['autorizzazionearea'] = this.template;
          this.filterID['templateTab']['autorizzazionearea'] = this.template;
          break;
  
        case 'autorizzazionecer':
          if (itemData.service == 'autorizzazione') {
            if (this.filterID['templateTab']['autorizzazione'] == 'form') {
              data['id'] = this.filterID['idAutorizzazione'];
            }
            this.filterID['isEdit'] = true;
          }
          if (itemData.service == 'autorizzazionearea') {
            if (this.filterID['templateTab']['autorizzazionearea'] == 'form') {
              data['id'] = this.filterID['idAutorizzazioneArea'];
              this.filterID['isEdit'] = true;
            }
          }
          break;
      }
  
      this.refreshPage(data, '', itemData.service, this.filterID['templateTab'][itemData.service], itemData);
      this.loader.hide();
    }, 500);
  }
  


  onOptionChanged(ev) {

  }

  async outputDataGridEvent(ev) {
    if(this.SubjectCall=='autorizzazionearea'){
      if(ev.name == "beforeEmitButtonDynamic"){
        const rowIndex = ev.rowIndex;

        let dataSourceModalitaSmaltimento = this.formAnagrafica.dataSet['listaModStoccaggioGeneric'];
        let dataSourceModalitaTrattamento = this.formAnagrafica.dataSet['listaModTrattamentoGeneric'];


        
        if(ev.dataField == 'listaModStoccaggio'){
          if(!dataSourceModalitaSmaltimento ){
            return
          }
          if(dataSourceModalitaSmaltimento.length==0){
            return
          }
          let  campoDynamic= ev.dynamic;
         
          ev.editor.dataJson = {
            listaModStoccaggioGeneric:dataSourceModalitaSmaltimento
          }

       
        } 

        if(ev.dataField == 'listaModTrattamento'){
          if(!dataSourceModalitaTrattamento ){
            return
          }
          if(dataSourceModalitaTrattamento.length==0){
            return
          }
          let  campoDynamic= ev.dynamic;
         
          ev.editor.dataJson = {
            listaModTrattamentoGeneric:dataSourceModalitaTrattamento
          }

        }
         
          
                
          
        
    
      }
            
    }
    
    
  }

  

  getDataAutorCer() {

    this.anagraficaService.getElenco(this.apiset, this.filterID['idAutorizzazione']).then((results:any) => {
      if(results['items']){
        results = results['items'];
        //this.autorizzazioneCerData = results['items'];
      }
      this.autorizzazioneCerData = results;

      this.showDynamicComponent = true;
     
      //this.dataAutorizzazioneCer.refresh();

      this.loader.hide();

    })

  }

  submitAutorizzazioneCer() {

    const idAutorizzazione = this.filterID['idAutorizzazione'];
    if(!this.autorizzazioneCerData || this.autorizzazioneCerData.length == 0 ){
        return
    }

    if(this.dataAutorizzazioneCer.inEditState){
      alert('Stai ancora modificando la griglia, ci sono dati da confermare', 'Attenzione')


      let rows = this.dataAutorizzazioneCer.righe.map(row => {
        let ro = row.nativeElement

        if (ro.classList.contains('error-row')) {
          ro.classList.remove('error-row')
        }

        return ro;

      });

      this.dataAutorizzazioneCer.editorData.forEach((editors, x) => {
        if (editors.edit)
          rows[editors.rowIndex].classList.add('error-row')
      })

      return
    }
   
    let api = this.apiset + '/' + idAutorizzazione
    this.refreshPage(this.filterID, '', this.SubjectCall, this.template)
    this.anagraficaService.actionInsert(api, this.autorizzazioneCerData).then(res => {
      this.refreshPage(this.filterID, '', this.SubjectCall, this.template)
    })

  }

  emittedGridEvent(event) {

    if (event.name == "saveEditorData") {
      //this.loader.show()
      const dataChanged = event.dataSource;
   

      this.autorizzazioneCerData = dataChanged


    }
  }

  async operazioniRecupSmalInAreaEER(campoDynamic,settingGrid,dataSourceModalita,dataS?){

    let instancedDataGrid = {
      service: campoDynamic.service,
      api: campoDynamic.dataSource,
      
      remoteOperation: true,
      rowAlternate: true,
      queryString: '',
      filterStatic: '',
      isEditable: settingGrid.isEditable,
      isEditableNewRow: settingGrid.allowAdding,
      isEditableEditRow: settingGrid.allowUpdating,
      isEditableDeleteRow: settingGrid.allowDeleting,
      tableHeight: settingGrid.height,
      tableWidth: settingGrid.width,
      showFilter: settingGrid.showFilter,
      searchType:settingGrid.searchType,
      colonne: settingGrid.colonne,
      selectionRowMode: settingGrid.selectionMode,
      selectedData: dataSourceModalita,
      overrideDataSource:null,
      showCaptionFooter: true,
      showCaptionHeader: false,
      isOdata: settingGrid.isOdata,
      idTable: '0listaModStoccaggio',
      showToolbarTop: settingGrid.showToolbarTop,
      showToolbarBottom: settingGrid.showToolbarBottom,
      toolbarButtonsTopLeft: settingGrid.toolbarButtonsTopLeft,
      toolbarButtonsTopRight: settingGrid.toolbarButtonsTopRight,
      toolbarButtonsBottomLeft: settingGrid.toolbarButtonsBottomLeft,
      toolbarButtonsBottomRight: settingGrid.toolbarButtonsBottomRight,
      isSearchable: settingGrid.searchAndSelect,
      
    }

    let title = campoDynamic.caption;

    let popupWidth = settingGrid.width;


    this.guidPop = this.openComponentInPopUP('NicaDataGridComponent',this.formAnagrafica.dataSet,instancedDataGrid,popupWidth,title,false,true);

    
  }
}
